export const CURRENT_APP_VERSION = '7.3.0' as const;
